import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

const LOAD_FOR_CURRENT_ENTITY_CANCELLATION_REASON = {
  invalidEmployee: 'Current employee edit is missing duplicate search fields',
  noEmployee: 'No current employee edit available',
} as const

/**
 * Samples the current employee edit, then forwards a duplicate lookup request
 * when it is usable.
 */
export const loadForCurrentEntity = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    feature.actions.loadForCurrentEntity.relay(
      forwardTo =>
        plugin.collection.plugins.currentEntityPlugin.feature.selectors
          .getEditedEntity()
          .asObservable.pipe(
            rxjs.take(1),
            rxjs.map(employee => {
              if (TypeChecker.isNullish(employee)) {
                return {
                  cancellation: {
                    reason:
                      LOAD_FOR_CURRENT_ENTITY_CANCELLATION_REASON.noEmployee,
                  },
                }
              }

              const { jobTitleId, name, organization } = employee
              if (
                TypeChecker.isFalsish(name) ||
                TypeChecker.isNullish(organization)
              ) {
                return {
                  cancellation: {
                    reason:
                      LOAD_FOR_CURRENT_ENTITY_CANCELLATION_REASON.invalidEmployee,
                  },
                }
              }

              return forwardTo(feature.actions.loadDuplicates, {
                input: {
                  jobTitleId,
                  name,
                  orgFilter: {
                    entityId: organization.entityId,
                    recordIds: [organization.recordId],
                  },
                },
                output: ({ response }) => response,
              })
            }),
          ),
      { strategy: 'switch' },
    ).asObservable,
)
